import Typography from "@mui/material/Typography";
import React from "react";
import { TicketErrorHelper } from "../../../Utils/TicketErrorHelper";
import { MenuCardContent, ValidationResult } from "../../../Utils/Interfaces";
import dayjs from "dayjs";
import { TICKET_DATE_FORMAT } from "../../TicketNavigator";
import { TicketExtended } from "../../../Utils/TypeExtensions";

export default function CustomerMenuContent(ticket: TicketExtended, title: string, companyName: string, jobLabel: string, errors: ValidationResult[]): MenuCardContent {
    const ticketDate = dayjs(ticket.date);
    const dateText = ticketDate.isValid() ? ticketDate.format(TICKET_DATE_FORMAT).toLocaleUpperCase() : "?";

    const details = (
        <>
            <Typography textAlign={"center"}>{`${companyName} - ${dateText}`}</Typography>
            <Typography textAlign={"center"}>{jobLabel}</Typography>
        </>
    );

    const validationMessages = TicketErrorHelper.getCardErrors(errors, title);

    return { details, validationMessages };
}
